import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { sliceResetFns } from "./utils";

type LiveViewersState = {
  /** Organization the counts belong to; another organization starts a new map. */
  organizationId: string | null;
  viewersByProject: Record<string, number>;
  /** When each count was set, so a newer seed can win over it. */
  updatedAtByProject: Record<string, number>;
};

type LiveViewersStore = LiveViewersState & {
  setProjectViewers: (
    organizationId: string,
    projectId: string,
    count: number
  ) => void;
  reset: () => void;
};

const initialState: LiveViewersState = {
  organizationId: null,
  viewersByProject: {},
  updatedAtByProject: {},
};

// Lives above the routes so the counts survive navigation; empty after a reload.
export const useLiveViewersStore = create<LiveViewersStore>()(
  devtools(
    (set) => {
      const reset = () => set(initialState, false, "reset");
      // Cleared on logout with the other slices.
      sliceResetFns.add(reset);

      return {
        ...initialState,

        setProjectViewers: (organizationId, projectId, count) =>
          set(
            (state) => {
              const isSameOrganization =
                state.organizationId === organizationId;
              return {
                organizationId,
                viewersByProject: {
                  ...(isSameOrganization ? state.viewersByProject : {}),
                  [projectId]: count,
                },
                updatedAtByProject: {
                  ...(isSameOrganization ? state.updatedAtByProject : {}),
                  [projectId]: Date.now(),
                },
              };
            },
            false,
            "setProjectViewers"
          ),

        reset,
      };
    },
    { name: "LiveViewersStore" }
  )
);
